import * as types from '../types.js';

export default {

	html: `
		<style>
			#filter .parens
			{
				padding: var(--space-xs) var(--space-md);
				border: 2px outset var(--color-border);
				background-color: var(--color-box);
			}
			#filter .parens[value="1"]
			{
				border: 2px inset var(--color-border);
			}
			#filter td:nth-child(1)	{ width: 1rem;	}
			#filter td:nth-child(2)	{ width: 2rem;	}
			#filter td:nth-child(3)	{ width: 10rem;	}
			#filter td:nth-child(4)	{ width: 10rem;	}
			#filter td:nth-child(5)	{ width: 14rem;	}
			#filter td:nth-child(6)	{ width: 2rem;	}
			#filter td:nth-child(7)	{ width: 2rem;	}
		</style>
		<form id="filter" class="form" autocomplete="off">
			<datalist id="fields">
			</datalist>
			<div class="filter-csv-tools" style="display:flex;align-items:center;flex-wrap:wrap;gap:0.5rem;margin-bottom:0.5rem">
				<input type="file" id="filter-import-csv" accept=".csv,text/csv,text/plain" style="display:none" />
				<button type="button" class="button" id="filter-btn-import-csv" title="Carregar linhas a partir de um CSV (campo, operador, dado, conector)">Importar filtro (CSV)…</button>
				<button type="button" class="button" id="filter-btn-csv-template" title="Baixar exemplo de colunas" style="opacity:0.92">Baixar modelo CSV</button>
			</div>
			<p class="muted" style="font-size:0.82rem;margin:0 0 0.5rem;line-height:1.35">Separador: ponto e vírgula (;). Campos aceitos: nome técnico ou rótulo (ex.: <code>id</code> ou <code>Saída</code>). Conectores: <strong>e</strong> (AND) ou <strong>ou</strong> (OR). Na última linha, deixe o conector vazio.</p>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th></th>
							<th>Campo</th>
							<th>Operador</th>
							<th>Dado</th>
							<th></th>
							<th>Conector</th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox" title="Seletor de linha">
							</td>
							<td>
								<button id="open-0" class="bn_Open parens" title="Inicia subgrupo lógico">(</button>
							</td>
							<td>
								<input id="field-0" type="text" list="fields" title="Campo a avaliar">
							</td>
							<td>
								<input id="operator-0" type="text" list="operators" title="Operador a utilizar na avaliação">
							</td>
							<td>
								<input id="value-0" type="text">
							</td>
							<td>
								<button id="close-0" class="bn_Close parens" title="Encerra subgrupo lógico">)</button>
							</td>
							<td>
								<input id="connector-0" type="text" list="connectors" title="Conexão lógica com a próxima linha">
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter linhas selecionadas">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conteúdo das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class="bn_Escape button" title="Fechar sem alterações">Fechar</button>
					<button class="bn_Enter button" title="Aplicar novo filtro">Aplicar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#filter',
	},

	fields: [
		{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
		{ properties: { selector: '#open-0' }, types: [types.button()] },
		{ properties: { selector: '#field-0' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#operator-0' }, types: [types.opt_operator(), types.datalist()] },
		{ properties: { selector: '#value-0' }, types: [] },
		{ properties: { selector: '#close-0' }, types: [types.button()] },
		{ properties: { selector: '#connector-0' }, types: [types.opt_connector(), types.datalist()] },
	]

}

